/**
 * Swatches selector component
 * 
 * @todo Change this component to swatchSelector.
 * @module swatches-selector
 * @version 1.0.0
 * @extends HTMLElement
 */

// Add CSS.escape polyfill for safe escaping of values
if (!window.CSS || !CSS.escape) {
  CSS.escape = function(value) {
    return value.replace(/([!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~])/g, '\\$1');
  };
}

class swatchComponent extends HTMLElement {

    /**
     * Product swatch selector web component.
     * 
     * @constructor
     */
    constructor() {

        super();
        
        // Track if user has manually selected a variant
        this.userHasInteracted = false;
        
        window.theme.product.loadProduct(this.dataset.handle, true).then(product => {

            this.render(product);
            
            // Check if product has Size option
            this.hasSizeOption = product.options.some(option => option === 'Size');
        });
    }

    /**
     * Render component in the DOM
     * 
     * @param {object} product Product data.
     * @returns {undefined}
     */
    render(product) {

        let html = this.getTemplate(),
            content = '';

        document.querySelectorAll('.swatches__swatch[data-option="default"]').forEach(el => {
          el.remove();
        });
        if (html && !this.querySelector('[data-option]')) {
            
            // Preserve the stock level container before overwriting innerHTML
            const stockLevelContainer = this.querySelector('.swatches__stocklevel-container');
            
            if (product.options.length >= 1) {

                product.options.forEach((option, index) => {

                    if (option.values.length === 1) {
                        content = content + `<div class='swatches__swatch single-value' data-option='${option.name}' data-position='${option.position}'>`;
                    } else {
                        content = content + `<div class='swatches__swatch' data-option='${option.name}' data-position='${option.position}'>`;
                    }
                    content = content + `<div class="swatches__swatch-label">${option.name}:</div>`;

                    content = content + `<div class="swatches__swatch-image"><div class="swatches__swatch-loading swatches__swatch-loading--image loading">loading</div></div>`;

                    content = content + `</div>`;
                });

                this.innerHTML = content;
                
                // Restore the stock level container temporarily at the top
                if (stockLevelContainer) {
                    // Ensure all stock level wrappers are hidden initially
                    stockLevelContainer.querySelectorAll('.variant-stocklevel-wrapper').forEach(wrapper => {
                        wrapper.classList.add('hidden');
                    });
                    this.insertBefore(stockLevelContainer, this.firstChild);
                }
            } 
        }

        

        this.loadSwatches(product);

        this.initEvents(product);
        
        this.selectFirstVariantAvailable(product);
        
        // After swatches are loaded, check if we should show stock level immediately
        this.checkInitialStockDisplay(product);
    }
    

    /**
     * Get component template
     * 
     * @returns {string} Component HTML template.
     */
    getTemplate() {

        return window.theme.swatchSelector.template ? window.theme.swatchSelector.template : '';
    }

    /**
     * Init component events.
     * 
     * @param {object} product Product data.
     * @returns {undefined}
     */
    initEvents(product) {

        // On swatch change

        this.querySelectorAll('[data-swatch-input]').forEach(element => {

            element.addEventListener('change', event => {
                this.onSwatchChange(event.target, product);
            });
        });

        // On variant selector ready

        let variantSelector = document.querySelector('variant-selector[data-handle="'+this.dataset.handle+'"]');

        if(variantSelector) {
            variantSelector.addEventListener('ready', event => {

                variantSelector.querySelector('select').addEventListener('change', event => {
                    this.updateSwatchValues();
                });
    
                this.selectFirstVariantAvailable(product);
                this.disableOutOfStockVariants(product);
            });
    
            // After varaint selector ready event
    
            if (variantSelector.classList.contains('ready')) {
    
                variantSelector.querySelector('select').addEventListener('change', event => {
                    this.updateSwatchValues();
                });
                
                this.selectFirstVariantAvailable(product);
                this.disableOutOfStockVariants(product);
            }
        }
    }

    /**
     * Load swatch inputs from a product
     * 
     * @param {object} product Product data.
     * @returns {undefined|boolean}
     */
    loadSwatches(product) {
        if (!window.theme.product.hasVariants(product))
            return false;

        // product.options = product.options.filter(option => {
        // return option.values.some(val => val.toLowerCase() !== 'default' && val.toLowerCase() !== 'default title');
        // });
        product.options.forEach((option) => {

            if (this.getImageSwatchOptions().includes( option.name.toUpperCase() )) {
                this.loadSwatchImage(option, product);
            } else {
                this.loadSwatchText(option, product);
            }
        });
    }

    /**
     * Get array of the custom option to be used as an image swatch.
     * 
     * @returns {Array} Array of the custom options.
     */
    getImageSwatchOptions() {

        if (typeof this.imageSwatchOptions == 'undefined') {

            this.imageSwatchOptions = window.theme.swatchSelector.imageTypes.toUpperCase().split('|');

            return this.imageSwatchOptions;

        } else {

            return this.imageSwatchOptions;
        }
    }

    /**
     * Get swatch element from DOM.
     * 
     * @returns {object} Swatch element.
     */
    getSwatchElement(optionName) {

        return this.querySelector(` [data-option='` + optionName.replace(/\s+/g, '-') + `']` );
    }

    /**
     * Render swatch as an image.
     * 
     * @param {object} product Product data.
     * @param {object} option Product option data.
     * @returns {undefined|boolean}
     */
    loadSwatchImage(option, product) {

        let element     = this.getSwatchElement(option.name),
            swatches    = window.theme.swatches.getSwatches(product, option.name),
            label       = this.getSwatchLabelTemplate(),
            finalHtml   = '';

        element.classList.add('swatches__swatch--image');
        element.classList.add('swatches__swatch--image-' + option.name.replace(/\s+/g, '-'));

        label = label.replace(/{{ option_name }}/g, option.name);

        option.values.forEach(value => {

            let html    = this.getSwatchImageTemplate(),
                image   = swatches.find(item => {return item.value == value}),
                id      = 'option-' + option.name.toLowerCase().replace(/\s+/g, '-') + '-' + value.toLowerCase().replace(/\s+/g, '-');

            if (!image || !image.src) return;

            html = html.replace(/{{ value }}/g, value);
            html = html.replace(/{{ name }}/g, option.name);
            html = html.replace(/{{ id }}/g, id);
            html = html.replace(/{{ src }}/g, image.src);

            finalHtml = finalHtml + html;
        });

        element.innerHTML = label + finalHtml;
    }

    /**
     * Render swatch as a text.
     * 
     * @todo Merge this fuction with loadSwatchImage.
     * @param {object} product Product data.
     * @param {object} option Product option data.
     * @returns {undefined|boolean}
     */
    loadSwatchText(option, product) {
        let element  = this.getSwatchElement(option.name);
        let label = this.getSwatchLabelTemplate();
        let finalHtml   = '';
       
        if (element) {

            let additionalClass = (option.values.length == 0) ? 'hidden' : '';
            element.classList.add('swatches__swatch--text');
            element.classList.add('swatches__swatch--text-' + option.name.replace(/\s+/g, '-'));
    
            label = label.replace(/{{ option_name }}/g, option.name);

            option.values.forEach(value => {
    
                let html    =  this.getSwatchTextTemplate('margin:0px !important; min-width: 38px !important; min-height: 26px !important;'),
                    id      = 'option-' + option.name.toLowerCase().replace(/\s+/g, '-') + '-' + value.toLowerCase().replace(/\s+/g, '-');

                html = html.replace(/{{ value }}/g, value);
                html = html.replace(/{{ name }}/g, option.name);
                html = html.replace(/{{ id }}/g, id);
                html = html.replace(/{{ additionalClass }}/g, additionalClass);
                
                finalHtml = finalHtml + html;

 
            });
            
            finalHtml = '<div class="swatches__boxes">' + finalHtml + '</div>';
    
            element.innerHTML = label + finalHtml;
            
            // For Size option, move the stock level container inside the label
            if(option.name == "Size") {
                const stockLevelContainer = this.querySelector('.swatches__stocklevel-container');
                const labelDiv = element.querySelector('.swatches__swatch-label > div');
                if (stockLevelContainer && labelDiv) {
                    // Ensure all variant wrappers are hidden initially
                    stockLevelContainer.querySelectorAll('.variant-stocklevel-wrapper').forEach(wrapper => {
                        wrapper.classList.add('hidden');
                    });
                    labelDiv.appendChild(stockLevelContainer);
                }
            }
        }
    }

    /**
     * Get swatch label html template.
     * 
     * @todo Move this template to a liquid file.
     * @returns {string} HTML template.
     */
    getSwatchLabelTemplate(loadstockLevelComponent = false) {

        return `<div class="swatches__swatch-label"><div>Select {{ option_name }}:&nbsp;<span data-swatch-label='{{ option_name }}'></span></div></div>`;
    }

    /**
     * Get swatch image html template.
     * 
     * @todo Move this template to a liquid file.
     * @returns {string} HTML template.
     */
    getSwatchImageTemplate() {

        return `<div class="image-swatches__swatch">` +
                    `<input type="radio" id="{{ id }}" name="{{ name }}" value='{{ value }}' aria-label='{{ value }}' data-swatch-input="{{ name }}">` + 
                    `<label for="{{ id }}">{{ value }}</label>` + 
                    `<img  loading= “lazy” src="{{ src }}" alt="{{ value }}"/>` + 
                `</div>`;
    }

    /**
     * Get swatch text html template.
     * 
     * @todo Move this template to a liquid file.
     * @returns {string} HTML template.
     */
    getSwatchTextTemplate(additionalStyle) {

        return `<div class="image-swatches__swatch" style="${additionalStyle}" >` +
                    `<input style="${additionalStyle}" type="radio" id="{{ id }}" name="{{ name }}" value='{{ value }}' aria-label='{{ value }}' data-swatch-input="{{ name }}">` + 
                    `<label style="padding: 7px !important; ${additionalStyle}" for="{{ id }}">{{ value }}</label>` + 
                '</div>';
    }

    /**
     * On swatch change.
     * 
     * @param {object} swatchInput Swatch input dom element.
     * @param {object} product Product data.
     * @returns {undefined}
     */
    onSwatchChange(swatchInput, product) {
        
        // Mark that user has interacted
        this.userHasInteracted = true;
        
        this.updateOptionLabel(swatchInput);

        let variant = this.getSelectedVariant(product);

        this.updateVariantSelector(variant);
        
        // Directly trigger variant-change event for stock level component
        if (variant) {
            this.triggerVariantChange(variant, product);
        }

        this.disableOutOfStockVariants(product);

    }

    /**
     * Get selected variant from swatch inputs.
     * 
     * @param {object} product Product data.
     * @returns {object} Product variant data.
     */
    getSelectedVariant(product) {

        // Create object with selected options 
        let selectedOptions = {};

        // Save the selected options in to the object
        this.querySelectorAll('[data-option]').forEach(element => {

            let input = element.querySelector('[data-swatch-input]:checked');

            if (input) {
                selectedOptions['option'+element.dataset.position] = input.value;
            }
        });

        // Find a product variant based on the selected options
        return product.variants.find((item) => {

            return ((item.option1 == selectedOptions.option1) && (item.option2 == selectedOptions.option2) && (item.option3 == selectedOptions.option3))
        });
    }

    /**
     * Update variant selector web component.
     * 
     * @param {object} variant Product variant data.
     * @returns {undefined}
     */
    updateVariantSelector(variant) {
        
        let variantSelectors = document.querySelectorAll('variant-selector[data-handle="' + this.dataset.handle + '"] select');

        if (variantSelectors.length) {
            variantSelectors.forEach((selector) => {

                selector.value = (variant) ? variant.id : '';

                selector.dispatchEvent(new Event("change"));
            });
        }
    }

    /**
     * Get variant selector web component.
     * 
     * @returns {object} Variant selector web component from DOM.
     */
    getVariantSelector() {
        return document.querySelector('variant-selector[data-handle="' + this.dataset.handle + '"] select');
    }

    /**
     * Update swatch option label with the current selected value.
     * 
     * @param {object} input Swatch input.
     * @returns {undefined}
     */
    updateOptionLabel(input) {
        this.querySelector(`[data-swatch-label='` + input.name + `']`).innerHTML  = input.value;
    }

    /**
     * Select the first variant available from a product in the variant selector component.
     * 
     * @param {object} product Product data.
     * @returns {undefined}
     */
    selectFirstVariantAvailable(product) {
        
        let firstAvailableOption = document.querySelector('variant-selector[data-handle="'+this.dataset.handle+'"] option[data-enabled]');

        if (firstAvailableOption) {
            
            let variant = product.variants.find(item => {return item.id == firstAvailableOption.dataset.variantId});
            
            this.selectVariant(variant);
            
        } else {
            // If no variant selector, select first available variant from product
            let firstAvailable = product.variants.find(v => v.available);
            
            if (firstAvailable) {
                this.selectVariant(firstAvailable);
            }
        }
    }

    /**
     * Select variant from a product in the variant selector component.
     * 
     * @todo Try to improve this code to reduce the code quantity.
     * @param {object} variant Product variant data.
     * @returns {undefined}
     */
    selectVariant(variant) {

      const option1Value = CSS.escape(variant.option1);
      const option2Value = CSS.escape(variant.option2);
      const option3Value = CSS.escape(variant.option3);
        if (variant) {
          
            let inputOption1 = this.querySelector(`[data-option][data-position='1'] input[value='`+option1Value+`']`);

            if (inputOption1) {
              if (inputOption1.parentNode.parentNode.querySelectorAll('.image-swatches__swatch').length === 1) {
                inputOption1.checked = true;
                this.updateOptionLabel(inputOption1);
              }
            }

            let inputOption2 = this.querySelector(`[data-option][data-position='2'] input[value='`+option2Value+`']`);
            if (inputOption2) {
              if (inputOption2.parentNode.parentNode.querySelectorAll('.image-swatches__swatch').length === 1) {
                inputOption2.checked = true;
                this.updateOptionLabel(inputOption2);
              }
            }

            let inputOption3 = this.querySelector(`[data-option][data-position='3'] input[value='`+option3Value+`']` );

            if (inputOption3) {
              if (inputOption3.parentNode.parentNode.querySelectorAll('.image-swatches__swatch').length === 1) {
                inputOption3.checked = true;
                this.updateOptionLabel(inputOption3);
              }
            }
        }
    }

    /**
     * Disable out of stock variant swatches.
     * 
     * @returns {undefined}
     */
    disableOutOfStockVariants() {
        
        let firstSelectedOption = {},
            secondSelectedOption = {},
            variantSelector = this.getVariantSelector();

        this.querySelectorAll('[data-option]').forEach(element => {

            element.querySelectorAll('[data-swatch-input]').forEach(input => {

                let selector   = '',
                    inputValue = input.value.replace(/\s+/g,'-'),
                    inputName  = input.name.replace(/\s+/g,'-');
                
                switch(element.dataset.position) {

                    case "1":

                        selector = `[data-swatches-option-`+inputName+`='`+inputValue+`'][data-enabled]`;

                        if(input.checked){
                            firstSelectedOption.name = inputName;
                            firstSelectedOption.value = inputValue;
                        }
                      
                        break;

                    case "2":

                        selector = `[data-swatches-option-`+firstSelectedOption.name+`='`+firstSelectedOption.value+`'][data-swatches-option-`+inputName+`='`+inputValue+ `'][data-enabled]`;

                        if(input.checked) {
                            secondSelectedOption.name = inputName;
                            secondSelectedOption.value = inputValue;
                        }
                    
                        break;

                    default: 

                        selector = `[data-swatches-option-`+firstSelectedOption.name+`='`+firstSelectedOption.value+`'][data-swatches-option-`+secondSelectedOption.name+`='`+secondSelectedOption.value+`'][data-swatches-option-`+inputName+`='`+inputValue+`'][data-enabled]`;

                        break;
                }

                let optionsVariantSelector = variantSelector.querySelectorAll(selector);

                if (optionsVariantSelector.length == 0 ) {

                    input.classList.add('disabled');

                } else {
                    
                    input.classList.remove('disabled');

                }
            });
        });
    }

    /**
     * Update swatch inputs.
     * 
     * @returns {undefined}
     */
    updateSwatchValues() {

    }
    
    /**
     * Trigger variant change event for components listening to variant changes
     * 
     * @param {object} variant Selected variant
     * @param {object} product Product data
     * @returns {object} Event that was triggered
     */
    triggerVariantChange(variant, product) {
        const event = new CustomEvent('variant-change', {
            detail: {
                variantId: variant.id,
                variant: variant,
                product: product
            }
        });
        
        window.dispatchEvent(event);
        
        // Also handle stock level display for product cards
        this.updateStockLevelDisplay(variant);
        
        return event;
    }
    
    /**
     * Update stock level display for the selected variant
     * 
     * @param {object} variant Selected variant
     * @returns {undefined}
     */
    updateStockLevelDisplay(variant) {
        // Only show stock level if user has interacted
        if (!this.userHasInteracted) {
            return;
        }
        
        // Find stock level wrappers within this swatch component
        const stockLevelContainer = this.querySelector('.swatches__stocklevel-container');
        
        if (stockLevelContainer) {
            // Hide all variant stock level wrappers
            const allWrappers = stockLevelContainer.querySelectorAll('.variant-stocklevel-wrapper');
            
            allWrappers.forEach(wrapper => {
                if (wrapper.dataset.variantId == variant.id) {
                    wrapper.classList.remove('hidden');
                } else {
                    wrapper.classList.add('hidden');
                }
            });
        }
    }
    
    /**
     * Check if stock level should be displayed on initial load
     * 
     * @param {object} product Product data
     * @returns {undefined}
     */
    checkInitialStockDisplay(product) {
        // Check if Size option exists and how many sizes are available
        const sizeOption = this.querySelector('[data-option="Size"]');
        
        if (sizeOption) {
            // Wait for swatches to be fully rendered
            setTimeout(() => {
                const availableSizes = sizeOption.querySelectorAll('[data-swatch-input]:not(.disabled)');
                
                // If only one size available, show stock immediately
                if (availableSizes.length === 1) {
                    this.userHasInteracted = true;
                    const selectedVariant = this.getSelectedVariant(product);
                    if (selectedVariant) {
                        this.updateStockLevelDisplay(selectedVariant);
                    }
                }
            }, 100);
        } else if (!this.hasSizeOption) {
            // No Size option at all - show stock immediately
            this.userHasInteracted = true;
            const selectedVariant = product.selected_or_first_available_variant || product.variants[0];
            if (selectedVariant) {
                this.updateStockLevelDisplay(selectedVariant);
            }
        }
    }
}

customElements.define('component-swatch', swatchComponent);
